/**
 * GuruOne frontend config
 * ─────────────────────────────────────────────────────────────────
 * In production (Railway), frontend and backend share the same domain
 * so API calls use a relative path. In local dev, the backend runs
 * on a separate port so we use the full localhost URL.
 */

const BASE = process.env.NODE_ENV === 'production'
  ? ''
  : 'http://localhost:3000';

export const API_BASE     = `${BASE}/api`;
export const CANVAS_API   = `${API_BASE}/canvas`;
export const FEEDBACK_API = `${API_BASE}/feedback`;
export const UPLOAD_API   = `${API_BASE}/upload`;
